// extracted by mini-css-extract-plugin
export var button = "styles-module--button--Jwp5O";
export var component = "styles-module--component--a9cBk";
export var hasAutoplay = "styles-module--has-autoplay--T+sJp";
export var hasPoster = "styles-module--has-poster--512Ca";
export var image = "styles-module--image--wMhmE";
export var poster = "styles-module--poster--W3MeI";
export var triangle = "styles-module--triangle--Xol-L";